import React from 'react';
import { Loader2 } from 'lucide-react';

interface LazyLoaderProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const LazyLoader: React.FC<LazyLoaderProps> = ({ 
  children, 
  fallback = (
    <div className="flex items-center justify-center min-h-[200px]">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  ) 
}) => {
  return (
    <React.Suspense fallback={fallback}>
      {children}
    </React.Suspense>
  );
};

// Preload function for critical components
export const preloadComponent = (importFn: () => Promise<any>) => {
  return () => {
    importFn();
    return Promise.resolve();
  };
};

// Preload critical components on user interaction
export const preloadCriticalComponents = () => {
  // Preload components when user hovers over navigation items
  const preloadOnHover = (importFn: () => Promise<any>) => {
    return () => {
      setTimeout(() => importFn(), 100);
    };
  };

  return {
    preloadWallet: preloadOnHover(() => import('@/pages/Wallet')),
    preloadContacts: preloadOnHover(() => import('@/pages/Contacts')),
    preloadProfile: preloadOnHover(() => import('@/pages/Profile')),
    preloadSettings: preloadOnHover(() => import('@/pages/Account')),
  };
}; 